// extracted by mini-css-extract-plugin
export default {"title":"AdditionalInfo_title__LAvnR","item":"AdditionalInfo_item__oNEEB"};